module.exports = __webpack_public_path__ + "img/dianhua.fb03dff6.png";